var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 26.122 24.438",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.55749 13.938c0-4.687 0-7.0304 1.8311-8.4865 1.8311-1.4561 4.7782-1.4561 10.672-1.4561 5.8941 0 8.8413 0 10.672 1.4561 1.8311 1.456 1.8311 3.7995 1.8311 8.4865 0 4.6869 0 7.0305-1.8311 8.4864-1.831 1.4561-4.7782 1.4561-10.672 1.4561-5.8942 0-8.8413 0-10.672-1.4561-1.8311-1.456-1.8311-3.7995-1.8311-8.4864z",
    strokeWidth: 1.115
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.9375,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.2251 14.464 2.1823-1.512c1.1353-0.78661 2.8465-0.74152 3.9132 0.1032l5.3445 4.2322c0.85617 0.67808 2.204 0.77052 3.1947 0.21912l0.37152-0.20669c1.4255-0.79341 3.3543-0.70146 4.6495 0.22159l4.0161 2.8622",
    strokeLinecap: "round",
    strokeWidth: 1.1087
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.9216 2.9668c1.7071-0.72841 5.5218-0.71365 9.9824-0.72753 4.5026-0.014015 8.7752-0.00327 10.296 0.78611",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.0627
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5644 0.8931c1.6744-0.24351 4.6272-0.37404 8.3651-0.38891 3.7731-0.015009 7.3047 0.19162 8.6281 0.45164",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.0067
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.93b0c7a9666a7e626c5706772fac3f8d.svg";
export { ForwardRef as ReactComponent };